import styled from '@emotion/styled';
import Button from '@/components/comm/Button';
import { breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

export const ResetPasswordForm = styled.form`
padding: 40px 32px;
background-color: ${colors.white};
border-radius: 15px;
text-align: center;

@media (max-width: ${breakpointSmall}) {
  padding: 40px 20px;
}
`;

export const ContentFirstDiv = styled.div`
color: ${colors.black};
font-size: 18px;
font-weight: 700;
line-height: 26px;
`;

export const ContentSecondDiv = styled.div`
margin-top: 17px;
margin-bottom: 122px;
color: ${colors.indigo};
font-size: 14px;
font-weight: 400;
line-height: 24px;

@media (max-width: ${breakpointSmall}) {
  margin-bottom: 60px;
}
`;

export const BottomBtn = styled(Button)`
width: 100%;
height: 54px;
margin-top: 175px;

@media (max-width: ${breakpointSmall}) {
  margin-top: 75px;
}
`;
